import { Component } from '@angular/core';

@Component({
    selector: 'mobilize-not-found',
    imports: [],
    templateUrl: './not-found.component.html',
    styleUrl: './not-found.component.scss'
})
export class NotFoundComponent {

}
